var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInstagram = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.417 17.333c.262 2.47 2.25 4.459 4.719 4.732 1.746.193 3.538.356 5.364.356s3.618-.163 5.365-.356c2.468-.274 4.457-2.262 4.719-4.732.184-1.736.337-3.517.337-5.333 0-1.815-.153-3.597-.337-5.333-.262-2.47-2.25-4.458-4.72-4.731-1.746-.194-3.538-.357-5.364-.357s-3.618.163-5.364.357c-2.47.273-4.457 2.261-4.72 4.731C2.233 8.403 2.08 10.185 2.08 12c0 1.816.153 3.597.338 5.333Z",
  stroke: "#58636A",
  strokeWidth: 1.5
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.5 15.741a3.741 3.741 0 1 0 0-7.482 3.741 3.741 0 0 0 0 7.482Z",
  stroke: "#58636A",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.186 6.227v.751",
  stroke: "#58636A",
  strokeWidth: 1.5,
  strokeLinecap: "round"
})));
export default SvgInstagram;